/**
 * Centralized scroll coordinator to prevent conflicting scroll operations.
 * Ensures only one smooth scroll operation runs at a time.
 */

let isScrolling = false;
let scrollTimeout: NodeJS.Timeout | null = null;

const SCROLL_DURATION = 400; // Reduced from 1000ms for faster interaction response

/**
 * Attempts to acquire a scroll lock. Returns true if successful, false if another scroll is in progress.
 */
export const tryAcquireScrollLock = (): boolean => {
  if (isScrolling) {
    return false;
  }

  isScrolling = true;

  // Clear any existing timeout
  if (scrollTimeout) {
    clearTimeout(scrollTimeout);
  }

  // Auto-release lock after scroll duration
  scrollTimeout = setTimeout(() => {
    isScrolling = false;
    scrollTimeout = null;
  }, SCROLL_DURATION);

  return true;
};

/**
 * Manually releases the scroll lock (optional, will auto-release after timeout).
 */
export const releaseScrollLock = (): void => {
  isScrolling = false;

  if (scrollTimeout) {
    clearTimeout(scrollTimeout);
    scrollTimeout = null;
  }
};

/**
 * Checks if a scroll operation is currently in progress.
 */
export const isScrollInProgress = (): boolean => {
  return isScrolling;
};
